import { z } from "zod";
export const fileContentTagSchema = z.object({
  id: z.string(),
  name: z.string(),
  color: z.string(),
});
export const fileContentSchema = z.object({
  id: z.string(),
  revision: z.number(),
  fileName: z.string(),
  sourceKind: z.enum(["matter", "firm"]),
  matterId: z.string().nullable(),
  massTortId: z.string().nullable(),
  matterFileId: z.string().nullable(),
  firmFileId: z.string().nullable(),
  documentDescription: z.string().nullable(),
  processingId: z.string().nullable(),
  status: z.string(),
  pageCount: z.number().nullable().optional(),
  tags: z.array(fileContentTagSchema).default([]),
});
export const fileContentPageSchema = z.object({
  id: z.string(),
  processingId: z.string(),
  pageNumber: z.number(),
  summary: z.string().nullable(),
  tags: z.array(fileContentTagSchema),
});
